import type React from 'react';
import type { PropsWithChildren } from 'react';

/* FC with children prop */
export type FCC<T = unknown> = React.FC<PropsWithChildren<T>>;

export type AnyFn = (...args: any[]) => any;

export const isOneOf = <const TThing, TListOfThings extends TThing[]>(
  thing: TThing,
  listOfThings: TListOfThings,
): thing is TListOfThings[number] => listOfThings.includes(thing);

type ObjectEntries<BaseType> = [keyof BaseType, BaseType[keyof BaseType]][];
/**
 * Typed version of Object.entries
 */
export const typedEntries = <T extends object>(base: T) => Object.entries(base) as ObjectEntries<T>;
